import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import VerificationLabel from "@/components/VerificationLabel";

/**
 * Institution card — used on Community Colleges / Universities index pages.
 * Props: institution (name, slug, type, location, common_destinations, verification_status)
 */
export default function InstitutionCard({ institution, basePath = "/institutions" }) {
  if (!institution) return null;
  const { name, slug, type, location, common_destinations, verification_status } = institution;
  const typeLabel = type === "community_college" ? "Community College" : type === "state_university" ? "State University" : "University";
  const locationStr = typeof location === "string"
    ? location
    : (location && [location.city, location.state].filter(Boolean).join(", ")) || null;
  return (
    <Link
      to={`${basePath}/${slug}`}
      className="border border-stone/40 bg-bone p-6 hover:border-ivy transition-colors group block"
      data-testid={`institution-card-${slug}`}
    >
      <div className="flex items-baseline justify-between mb-3">
        <span className="text-[10px] uppercase tracking-[0.22em] text-brass font-semibold">{typeLabel}</span>
        <VerificationLabel status={verification_status || "awaiting"} />
      </div>
      <h3 className="font-serif text-2xl text-ivy tracking-tight group-hover:text-brass transition-colors">{name}</h3>
      {locationStr && (
        <p className="flex items-center gap-1.5 text-xs text-stone mt-2 uppercase tracking-[0.18em]">
          <MapPin className="h-3 w-3" /> {locationStr}
        </p>
      )}
      {common_destinations && common_destinations.length > 0 && (
        <div className="mt-5 pt-4 border-t border-stone/30">
          <div className="text-[10px] uppercase tracking-[0.22em] text-stone mb-2">Common transfer destinations</div>
          <div className="text-sm text-ink-soft leading-relaxed">{common_destinations.slice(0, 4).join(" · ")}</div>
        </div>
      )}
      <div className="mt-5 flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] font-semibold text-ivy group-hover:gap-2.5 transition-all">
        Open profile <ArrowRight className="h-3 w-3" />
      </div>
    </Link>
  );
}
